import { SLOTS_APIS } from "@/api_framework/api_config";
import { ISingleBookingDetailsResponse, ISingleBookingDetailsResponseData } from "@/api_framework/api_modals/Bookings";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setRescheduledBooking } from "@/app_redux/reducers/slices/auth/slots_slice";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";
import { useCurlLogger } from "../../useCurlLogger";

AxiosCurlirize(axios, () => {});

export const useSingleBookingDetailsAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const execute = useCallback(
    async (bookingId: string, isRescheduled: boolean = false, appendTrailingSlash: boolean = false) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);

        const response: ISingleBookingDetailsResponseData = await axios
          .get(`${SLOTS_APIS?.SINGLE_BOOKING_DETAILS?.baseURL}${bookingId}${appendTrailingSlash ? "/" : ""}`, {
            params: {},
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<ISingleBookingDetailsResponse>) => {
            if (res.data.status === true && res.data) {
              if (isRescheduled) {
                dispatch(
                  setRescheduledBooking({
                    data: res.data.data,
                  }),
                );
              }
              return res.data.data;
            } else {
              //TODO: When it fails
              return null;
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);

            if (e.code === "ERR_BAD_REQUEST") {
              toast.error("No bookings found");
            }
            return null;
          });
        return response;
      } catch (e: any) {
        toast.error("Server Error: " + e.message);
      }
    },
    [dispatch],
  );
  return execute;
};
